import { render, staticRenderFns } from "./tenantDetails.vue?vue&type=template&id=b7889358&"
import script from "./tenantDetails.vue?vue&type=script&lang=js&"
export * from "./tenantDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports